import React, {useEffect, useState} from 'react'
import {Modal, ModalBody} from 'reactstrap'
import {ReactComponent as TimesIcon} from '../../../assets/icons/times.svg'
import {ReactComponent as SearchIcon} from '../../../assets/icons/search.svg'
import {ReactComponent as ArrowDown} from '../../../assets/icons/keyboard_arrow_down.svg'
import {ReactComponent as Clock} from '../../../assets/icons/clock.svg'
import {ReactComponent as Times} from '../../../assets/icons/times.svg'
import {getFilterResources, getProductCategories, getSearchProducts} from '../../../services/ProductServices'
import UseDebounce from '../../../hooks/useDebounce';
import {ReactComponent as ChevronLeft} from '../../../assets/icons/chevron-left.svg'
import {ReactComponent as ChevronRight} from '../../../assets/icons/chevron-right.svg'
import {getListSKUPrivate} from '../../../services/ProductLinesServices'

const mapFilters = {
    ffm_locations: 'Fulfillment location',
    print_area: 'Print Area',
    techniques: 'Techniques'
}

const ChangeProductModal = (props) => {
    const {isOpen, toggleModal} = props
    const [inputSearch, setInputSearch] = useState('')
    const [products, setProducts] = useState([])
    const [selectedCategory, setSelectedCategory] = useState(null)
    const [total, setTotal] = useState(0)
    const [filterCategory, setFilterCategory] = useState(false)
    const [isSearchInput, setIsSearchInput] = useState(false)
    const [filterResource, setFilterResource] = useState({})
    const [filters, setFilters] = useState({page: 1, limit: 50, orderBy: 'popularity', order: 'desc'})
    const [categories, setCategories]= useState({center_menu: [], left_menu: []})
    const [searchHistories, setSearchHistories] = useState([])
    const [privateSKUs, setPrivateSKUs] = useState([])

    const debouncedSearch = UseDebounce(inputSearch, 300);

    const onChangeCategory = (category) => {
        setSelectedCategory(category)
        setFilterCategory(false)
        setFilters({
            ...filters,
            page: 1,
            category: category._id
        })
    }

    const onClearFilterCategory = () => {
        setSelectedCategory(null)
        setFilterCategory(false)
        setFilters({
            ...filters,
            page: 1,
            category: ''
        })
    }

    const onChangeCheckbox = (key, e) => {
        const {checked, value} = e.target
        if (checked) {
            const values = filters[key] || []
            setFilters({
                ...filters,
                page: 1,
                [key]: [...values, value]
            })
        } else {
            const values = filters[key] || []
            setFilters({
                ...filters,
                page: 1,
                [key]: values.filter(item => item !== value)
            })
        }
    }

    const onChangeState = (newFilters) => {
        setFilters({
            ...filters,
            ...newFilters
        })
    }

    const toggleCategories = () => {
        setFilterCategory(!filterCategory)
        setIsSearchInput(false)
    }

    const onChangeInput = (e) => {
        const {value} = e.target
        setInputSearch(value)
    }

    const onClickInput = () => {
        let localSearchHistory = localStorage.getItem('searchProductsHistory') || ''
        let historySearch = localSearchHistory ? JSON.parse(localSearchHistory) : []
        setSearchHistories(historySearch)
        setIsSearchInput(true)
        setFilterCategory(false)
    }
    
    const fetchFilterResources = async () => {
        try {
            const response = await getFilterResources()
            console.log(response)
            setFilterResource(response)
        } catch (e) {
            console.log(e.message)
        }
    }

    const fetchListSKUPrivate = async () => {
        try {
            const { data, success, message } = await getListSKUPrivate()

            if (!success) {
                throw new Error(message)
            }

            setPrivateSKUs(data)

        } catch (e) {
            console.log(e.message)
        }
    }

    const fetchProductCategories = async () => {
        try {
            const response = await getProductCategories()
            setCategories(response)
        } catch (e) {
            console.log(e.message)
        }
    }

    const getProductRange = (totalProducts, productsPerPage, currentPage) => {
        if (totalProducts === 0) return "0 products";

        const start = (currentPage - 1) * productsPerPage + 1;
        const end = Math.min(currentPage * productsPerPage, totalProducts);

        return <div className='Total'>Showing <span>{start}-{end}/{totalProducts}</span> products</div>;
    };

    const getTotalPages = (totalProducts, productsPerPage) => {
        return Math.ceil(totalProducts / productsPerPage);
    };

    const fetchSearchProducts = async (search = '') => {
        try {
            const response = await getSearchProducts({
                ...filters,
                privateSKUs,
                search: search || inputSearch
            })
            if (inputSearch) saveProductHistorySearch(inputSearch)
            const {products = [], total} = response
            setTotal(total)
            setProducts(products)
        } catch (e) {
            console.log(e.message)
        }
    }

    const saveProductHistorySearch = (search) => {
        const localProductsSearchHistory = localStorage.getItem('searchProductsHistory') || ''
        const historySearch = localProductsSearchHistory ? JSON.parse(localProductsSearchHistory) : []
        if (!historySearch.find(item => item.name === search.toLowerCase())) {
            historySearch.push({
                name: search.toLowerCase()
            })
            localStorage.setItem('searchProductsHistory', JSON.stringify(historySearch))
        } else {
            const _historySearch = historySearch.filter(item => item.name !== search.toLowerCase())
            _historySearch.push({
                name: search.toLowerCase()
            })
            localStorage.setItem('searchProductsHistory', JSON.stringify(_historySearch))
        }
    }

    const generateTag = (tag) => {
        switch (tag) {
            case 'New':
                return <span className='tag new'>New</span>
            case 'Trending':
                return <span className='tag trending'>Trending</span>
            case 'Bestseller':
                return <span className='tag bestseller'>Bestseller</span>
            default:
                return ''
        }
    }

    useEffect(() => {
        fetchFilterResources()
        fetchProductCategories()
        fetchListSKUPrivate()
    }, [])

    useEffect(() => {
        fetchSearchProducts()
    }, [filters])

    useEffect(() => {
        // Khi debouncedSearch thay đổi, reset page về 1
        setFilters(prev => ({
            ...prev,
            page: 1
        }));
    }, [debouncedSearch]);

    return (
        <div className="ChangeProductModal">
            <Modal
                isOpen={isOpen}
                className={`ChangeProductModal`}
                toggle={toggleModal}
            >
                <ModalBody>
                    <div className="HeadingChangeProduct">
                        <div className="SelectProduct">
                            <div className={`ButtonSelectProduct ${filterCategory ? 'active' : ''}`}>
                                <span onClick={toggleCategories}>{selectedCategory ? selectedCategory.display_name : 'All Products'}</span>
                                <ArrowDown width={20} onClick={toggleCategories}/>
                                { selectedCategory && <Times width={10} height={10} onClick={onClearFilterCategory}/>}
                            </div>
                            {filterCategory && (
                                <div className='CategoryTree'>
                                    <div className='CategoryColumn CategoryLeft'>
                                        <ul>
                                            {categories?.left_menu.length > 0 && categories?.left_menu.map(item => {
                                                const childs = item.children || []
                                                return <li className={`${selectedCategory?._id === item._id ? 'active' : ''}`} onClick={() => onChangeCategory(item)}>
                                                    {item.display_name || ''}
                                                    {childs.length > 0 && (
                                                        <ul>
                                                            {childs.map(child => {
                                                                return <li className={`${selectedCategory?._id === child._id ? 'active' : ''}`} onClick={() => onChangeCategory(child)}>{child.display_name || ''}</li>
                                                            })}
                                                        </ul>
                                                    )}
                                                </li>
                                            })}
                                        </ul>
                                    </div>
                                    {categories?.center_menu.length > 0 && categories?.center_menu.map(itemCenter => {
                                        const childs = itemCenter.children || []
                                        return (
                                            <div className='CategoryColumn'>
                                                <label>{itemCenter.display_name || ''}</label>
                                                {childs.length > 0 && (
                                                    <ul>
                                                        {childs.map(child => {
                                                            return <li className={`${selectedCategory?._id === child._id ? 'active' : ''}`} onClick={() => onChangeCategory(child)}>{child.display_name || ''}</li>
                                                        })}
                                                    </ul>
                                                )}
                                            </div>
                                        )
                                    })}
                                </div>
                            )}
                        </div>
                        <div className='SearchProduct'>
                            <SearchIcon width={20} />
                            <input type='text' value={inputSearch} onChange={onChangeInput} onClick={onClickInput}
                                   placeholder='Search product' />
                            {(isSearchInput && searchHistories.length > 0 && inputSearch === '') && (
                                <div className='RecentSearch'>
                                    <h5>Recent Searches</h5>
                                    <ul>
                                        {
                                            searchHistories.map(item => {
                                                return <li onClick={() => setInputSearch(item.name)}><Clock width={20}/> {item.name || ''}</li>
                                            })
                                        }
                                    </ul>
                                    <div className="BgSearchHítory" onClick={() => setIsSearchInput(false)}></div>
                                </div>
                            )}
                        </div>
                        <div className='IconClose' onClick={toggleModal}>
                            <TimesIcon width={20} />
                        </div>
                    </div>
                    <div className='ContentChangeProduct'>
                        <div className='ContentLeft'>
                            {
                                Object.keys(filterResource).length > 0 && Object.keys(filterResource).map(key => {
                                    const values = filterResource[key]
                                    return <div className='FilterBox'>
                                        <h4>{mapFilters[key] || ''}</h4>
                                        <div className='ListFilters'>
                                            {
                                                values.length > 0 && values.map(item => {
                                                    return <div className='FilterItem'>
                                                        <input id={item._id} value={item._id} type='checkbox' onChange={(e) => onChangeCheckbox(key, e)}/>
                                                        <label htmlFor={item._id}>{item.name}</label>
                                                    </div>
                                                })
                                            }
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                        <div className='ContentRight'>
                            <div className="ContentTop d-flex justify-content-between">
                                <div className="SortBy">
                                    <label>Sort by:</label>
                                    <ul>
                                        <li onClick={() => onChangeState({orderBy: 'popularity', order: 'desc', page: 1})} className={`${filters.orderBy === 'popularity' ? 'active' : ''}`}>Popular</li>
                                        <li onClick={() => onChangeState({orderBy: 'published_at', order: 'desc', page: 1})} className={`${filters.orderBy === 'published_at' ? 'active' : ''}`}>Latest</li>
                                        <li onClick={() => onChangeState({orderBy: 'price', order: 'asc', page: 1})} className={`${(filters.orderBy === 'price' && filters.order === 'asc') ? 'active' : ''}`}>Price: low - high</li>
                                        <li onClick={() => onChangeState({orderBy: 'price', order: 'desc', page: 1})} className={`${(filters.orderBy === 'price' && filters.order === 'desc') ? 'active' : ''}`}>Price: high - low</li>
                                    </ul>
                                </div>
                                <div className='Pagination'>
                                    {getProductRange(total, filters.limit, filters.page)}
                                    <span className={`${filters.page === 1 ? 'disabled' : ''}`} onClick={() => onChangeState({page: filters.page - 1})}><ChevronLeft /></span>
                                    <span className={`${getTotalPages(total, filters.limit) === filters.page ? 'disabled' : ''}`} onClick={() => onChangeState({page: filters.page + 1})}><ChevronRight /></span>
                                </div>
                            </div>
                            <h3>You may also like</h3>
                            <main className='product-list'>
                                {
                                    products.map((product, index) => {
                                        console.log(product)
                                        const countAttributes = product.count_attributes || {}
                                        const {tags = []} = product
                                        const attributes = Object.keys(countAttributes).length > 0 ? Object.keys(countAttributes).map(key => {
                                            return `${countAttributes[key]} ${key.toLowerCase()}`
                                        }) : []
                                        return <div key={`product-${index}`} className='product'>
                                            <div className='img-thumbnail'>
                                                <a href={`/${product.id}`}>
                                                    <img
                                                        src={product?.media?.thumbnail}
                                                        alt='Hawaiian Shirt' />
                                                </a>
                                                <div className='tags'>
                                                    {tags.map(tag => generateTag(tag))}
                                                </div>
                                            </div>
                                            <div className='info-product'>
                                                <h2><a href={`/${product.id}`}>{product.title || ''}</a></h2>
                                                <p className='price'>
                                                    <span>${product.price || ''}</span>
                                                    {/*$32.99 <span>$26.99</span>*/}
                                                </p>
                                                <p className='sku'><label>SKU:</label> {product.sku || ''}</p>
                                                <p className='sizes'>{attributes.length > 0 ? attributes.join(' - ') : ''}</p>
                                            </div>
                                        </div>
                                    })
                                }
                            </main>
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        </div>
    )
}

export default ChangeProductModal